import { SmileyIcon } from '~/@mid_ui/icons/SmileyIcon'

type Props = {
  reference: string
  description: string
}

export const AmbassadorInviteBanner = ({ reference, description }: Props) => {
  return (
    <div className="flex flex-row w-full gap-2 p-3 pb-4 bg-[#DAFFC7]">
      <SmileyIcon className="text-[#3BB300]" />

      <div className="flex flex-col gap-2">
        <h4 className="text-base font-semibold font-foreground">
          {reference} Vás pozýva investovať
        </h4>

        <p className="text-sm font-medium text-foreground">{description}</p>
      </div>
    </div>
  )
}
